var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgExpandContent = function SvgExpandContent(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 24 24",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7 17h3q.424 0 .713.288.287.287.287.712 0 .424-.287.712A.97.97 0 0 1 10 19H6a.97.97 0 0 1-.713-.288A.97.97 0 0 1 5 18v-4q0-.424.287-.713A.97.97 0 0 1 6 13q.424 0 .713.287Q7 13.576 7 14zM17 7h-3a.97.97 0 0 1-.713-.287A.97.97 0 0 1 13 6q0-.424.287-.713A.97.97 0 0 1 14 5h4q.424 0 .712.287Q19 5.576 19 6v4q0 .424-.288.713A.97.97 0 0 1 18 11a.97.97 0 0 1-.712-.287A.97.97 0 0 1 17 10z"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgExpandContent);
export { ForwardRef as ReactComponent };